import { render, staticRenderFns } from "./sepa-merger.vue?vue&type=template&id=fab0a2d8&scoped=true&"
import script from "./sepa-merger.vue?vue&type=script&lang=js&"
export * from "./sepa-merger.vue?vue&type=script&lang=js&"
import style0 from "./sepa-merger.vue?vue&type=style&index=0&id=fab0a2d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fab0a2d8",
  null
  
)

export default component.exports